const TwoColumnLayout = ({ sidebar, children }) => {
  return (
    <div className="w-full min-h-screen bg-bg text-text">

      {/* DESKTOP */}
      <div className="hidden min-[942px]:flex w-full h-screen">

        <aside className="w-[46%] h-full border-r border-border bg-accent overflow-y-auto">
          {sidebar}
        </aside>

        <main
          id="scroll-root"
          className="flex-1 h-full overflow-y-auto"
        >
          {children}
        </main>

      </div>

      {/* MOBILE */}
      <main
        id="scroll-root"
        className="lg:hidden min-h-screen overflow-y-auto"
      >
        {children}
      </main>

    </div>
  );
};

export default TwoColumnLayout;

